

// ----------------------------------------------------------------------



const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  // comingSoon: '/coming-soon',
  contactus: '/contactus',
  // dashSupport: '/dashSupport',
  // contact: '/contact-us',
  // page403: '/error/403',
  // page404: '/error/404',
  // page500: '/error/500',
 
  // auth: {

  //   jwt: {
  //     login: `${ROOTS.AUTH}/jwt/login`,
  //     register: `${ROOTS.AUTH}/jwt/register`,
  //   },
  
  // },

  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    home: `${ROOTS.DASHBOARD}/home`,
    dashSupport: `${ROOTS.DASHBOARD}/dashSupport`,
    dashProfile: `${ROOTS.DASHBOARD}/dashProfile`,
    dashPlans: `${ROOTS.DASHBOARD}/dashPlans`,
    referAndEarn: `${ROOTS.DASHBOARD}/referAndEarn`,
    // general: {
    //   app: `${ROOTS.DASHBOARD}/app`,
    //   ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
    //   analytics: `${ROOTS.DASHBOARD}/analytics`,
    //   banking: `${ROOTS.DASHBOARD}/banking`,
    //   booking: `${ROOTS.DASHBOARD}/booking`,
    //   file: `${ROOTS.DASHBOARD}/file`,
    // },
   
  },
};
